import { z } from 'zod';

/** Perfis do painel (RF-078). */
export const perfilUsuarioSchema = z.enum(['Administrador', 'Supervisor', 'Consulta']);

export const usuarioSessaoSchema = z.object({
  id: z.string(),
  nome: z.string(),
  usuario: z.string(),
  perfil: perfilUsuarioSchema,
});

export const tenantSessaoSchema = z.object({
  id: z.string(),
  nome: z.string(),
});

/**
 * Corpo devolvido por `POST /autenticacao/entrar` e `GET /autenticacao/eu`.
 *
 * O token da sessão **não** aparece aqui: ele viaja só no cookie `wms_sessao`,
 * que é HttpOnly. O JavaScript do painel não lê nem guarda sessão em lugar
 * nenhum — descobrir se há sessão é sempre perguntar ao middleware.
 */
export const sessaoSchema = z.object({
  usuario: usuarioSessaoSchema,
  tenant: tenantSessaoSchema,
});

export type PerfilUsuario = z.infer<typeof perfilUsuarioSchema>;
export type UsuarioSessao = z.infer<typeof usuarioSessaoSchema>;
export type TenantSessao = z.infer<typeof tenantSessaoSchema>;
export type Sessao = z.infer<typeof sessaoSchema>;

/** Iniciais para o avatar: primeira e última palavra do nome, no máximo duas letras. */
export function iniciaisDoNome(nome: string): string {
  const partes = nome.trim().split(/\s+/).filter(Boolean);
  const primeira = partes.at(0)?.charAt(0) ?? '';
  const ultima = partes.length > 1 ? (partes.at(-1)?.charAt(0) ?? '') : '';
  return (primeira + ultima).toUpperCase();
}
